import { getCartErrorMessage } from '@theme/cart-feedback';

// <s-quick-add> adds one unit of a card's first available variant without a product form,
// for grids that already sit inside another form (collection filters). Falls back to the product page.
class SQuickAdd extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('command', (event) => {
      if (event.command === '--add') this.#add(event.source);
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  async #add(button) {
    const variantId = this.dataset.variantId;
    if (!variantId || this.getAttribute('aria-busy') === 'true') return;
    if (!window.Shopify?.actions?.updateCart) {
      if (this.dataset.productUrl) window.location.href = this.dataset.productUrl;
      return;
    }

    this.setAttribute('aria-busy', 'true');
    button?.setAttribute('aria-disabled', 'true');
    this.#showError('');
    try {
      const result = await window.Shopify.actions.updateCart(
        { lines: [{ merchandiseId: variantId, quantity: 1 }] },
        { event: { context: 'collection', detail: { source: 's-quick-add', productId: this.dataset.productId } } }
      );
      const message = result?.userErrors?.[0]?.message;
      if (message) this.#showError(message);
      else await window.Shopify.actions.openCart?.();
    } catch (error) {
      this.#showError(getCartErrorMessage?.(error) || this.dataset.errorMessage || '');
    } finally {
      this.removeAttribute('aria-busy');
      button?.removeAttribute('aria-disabled');
    }
  }

  #showError(message) {
    const error = this.querySelector('[data-quick-add-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }
}

if (!customElements.get('s-quick-add')) customElements.define('s-quick-add', SQuickAdd);
